module.exports = __webpack_public_path__ + "static/img/top_message_catch.e6195b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/company/top_message_catch.png
// module id = dS3f
// module chunks = 0